import React from 'react';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox } from 'antd';

export interface CheckOptions {
  childrens: React.ReactElement;
  onChange: (e: CheckboxChangeEvent) => void;
}
export const AgreementCheckbox = (props: CheckOptions) => {
  return <Checkbox onChange={props.onChange}>{props.childrens}</Checkbox>;
};
